
























import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  MentoringBagIcon,
  MentoringManIcon,
  MentoringBoyIcon,
  MentoringGirlIcon,
  MentoringDummyIcon,
  MentoringWomanIcon,
  MentoringOldManIcon,
  MentoringOldWomanIcon,
} from './components';
import { IAvatarStub, TypeEnum } from './types';

@Component({
  components: {
    MentoringBagIcon,
    MentoringManIcon,
    MentoringBoyIcon,
    MentoringGirlIcon,
    MentoringDummyIcon,
    MentoringWomanIcon,
    MentoringOldManIcon,
    MentoringOldWomanIcon,
  },
})
export default class MentoringAvatarStub extends Vue implements IAvatarStub {
  @Prop({ type: String, default: 'N' })
  readonly gender!: string;

  @Prop({ type: String, default: '' })
  readonly type!: string;

  @Prop({ type: Boolean, default: false })
  readonly asCurator!: boolean;

  readonly maleViewBox: string = '0 0 313.41 511';
  readonly femaleViewBox: string = '0 0 97.28 215.13';
  readonly nogenderViewBox: string = '0 0 80 80';

  get isCurator() {
    return this.type === TypeEnum.CURATOR;
  }

  get isMentor() {
    return this.type === TypeEnum.MENTOR;
  }

  get viewBox(): string {
    const {
      gender,
      maleViewBox,
      femaleViewBox,
      nogenderViewBox,
      isCurator,
      isMentor,
    } = this;
    if (isCurator || isMentor || gender === 'N') return nogenderViewBox;
    if (gender === 'M') return maleViewBox;
    return femaleViewBox;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/MentoringAvatarStub.vue